import { render } from "./CareerDirections.vue?vue&type=template&id=5aacb900"
import script from "./CareerDirections.vue?vue&type=script&lang=js"
export * from "./CareerDirections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__